import React from "react";
import { navigate } from "gatsby";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { buttonPurple } from "@/styles/styles";

// Fallback translations
const fallbackText = {
  en: "Get Started Today!",
  es: "¡Comienza Hoy!",
};

export default function GetStartedButton({ affiliateLink, onClose, t }) {
  const { language } = useLanguage();

  if (!affiliateLink) return null;

  const buttonText = t ? t("reviews.cta.getStarted") : (fallbackText[language] || fallbackText.en);

  const handleClick = (e) => {
    e.preventDefault();

    if (onClose) {
      onClose();
    }

    // Wait for modal close animation to complete before navigating
    setTimeout(() => {
      navigate(affiliateLink);
    }, 300);
  };

  return (
    <Button
      onClick={handleClick}
      className={`${buttonPurple} w-full min-h-[48px] font-semibold transition-all duration-300`}
    >
      {buttonText}
    </Button>
  );
}
